import {
  ComponentBuilder,
  ComponentBuilderFetchDataInputs,
} from 'strapi/componentBuilder';
import { PageTypes } from 'strapi/page/types';

import { collectHeroSectionComponentParams } from './collector';
import { HeroSection } from './HeroSection';
import { HeroSectionStrapiComponent } from './types';

export class HeroSectionComponentBuilder extends ComponentBuilder {
  public key = 'banners.hero-section' as const;

  async fetchData(inputs: ComponentBuilderFetchDataInputs) {
    const fieldName = this.getFieldNameSymbol(inputs.componentData);

    const page = await inputs.fetchManager.addRequestOptionsAndWaitForResponse<{
      fieldName: HeroSectionStrapiComponent;
    }>({
      populate: {
        [fieldName]: {
          populate: {
            buttons: true,
            image: true,
          },
        },
      },
    });

    const componentData = page[fieldName];
    if (!componentData) {
      return undefined;
    }

    const collectedParams = collectHeroSectionComponentParams(
      componentData,
      // We force the type to be PageTypes just to satisfy the type checker
      // and to be able to re-use the code of the collector in this context
      page as unknown as PageTypes
    );

    return collectedParams;
  }

  render(inputs: Awaited<ReturnType<(typeof this)['fetchData']>>) {
    if (inputs) {
      return <HeroSection {...inputs} />;
    } else {
      return null;
    }
  }
}
